import { render } from "./ClientSettingsUI.vue?vue&type=template&id=eba90636&scoped=true"
import script from "./ClientSettingsUI.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientSettingsUI.vue?vue&type=script&charset=utf-8&lang=js"

import "./ClientSettingsUI.vue?vue&type=style&index=0&id=eba90636&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eba90636"]])

export default __exports__